import React from "react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/AlertDialog";
import { actionIsNotStarted } from "./util";
import { RiseUserAction } from "@/types/RiseUserAction";
import { useTranslation, Trans } from "react-i18next";

<Trans i18nKey="common.greeting" />;

export const ConfirmationDialog = ({
  open,
  onOpenChange,
  onConfirm,
  action,
}: {
  open: boolean;
  action: RiseUserAction;
  onOpenChange: (open: boolean) => void;
  onConfirm: (action: RiseUserAction) => void;
}) => {
  const { t } = useTranslation("translation", {
    keyPrefix: "strategyBoard.confirmationAlert",
  });

  const title = actionIsNotStarted(action)
    ? t("markAllDone")
    : t("markRemainingDone");

  const desc = actionIsNotStarted(action) ? (
    <Trans i18nKey="strategyBoard.confirmationAlert.markAllDoneDesc" />
  ) : (
    <Trans i18nKey="strategyBoard.confirmationAlert.markRemainingDoneDesc" />
  );

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          <AlertDialogDescription>{desc}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>{t("cancel")}</AlertDialogCancel>
          <AlertDialogAction onClick={() => action && onConfirm(action)}>
            {t("confirm")}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
